<template>
  <b-container
    fluid
    class="w-100 h-100 m-0 p-0 pt-2"
  >
    <b-row class="w-100 h-100 m-0 p-0">
      <b-col
        cols="4"
        class="h-100 table-column p-0"
      >
        <div class="table-btn-div">
          <b-button
            v-if="anySelected"
            v-b-hover="handleDeleteHover"
            size="sm"
            variant="danger"
            class="m-0 py-0 px-1"
            @click="deleteSelected"
          >
            <b-icon
              v-if="hoverDelete"
              aria-label="Delete Selected"
              icon="x-square"
            />
            <b-icon
              v-else
              aria-label="Delete Selected"
              icon="x-square-fill"
            />
          </b-button>
          <b-button
            v-b-hover="handleAddHover"
            size="sm"
            variant="success"
            class="m-0 py-0 px-1"
            @click="addValue"
          >
            <b-icon
              v-if="hoverAdd"
              aria-label="Add Value"
              icon="plus-square"
            />
            <b-icon
              v-else
              aria-label="Add Value"
              icon="plus-square-fill"
            />
          </b-button>
        </div>
        <div
          ref="divTable"
          class="table-div"
        >
          <vue-table-dynamic
            ref="tableArea"
            :params="paramsTable"
            class="m-0 p-0"
            @cell-change="onCellChange"
            @select="onCellSelected"
            @select-all="onCellSelected"
          />
        </div>
      </b-col>
      <b-col
        cols="8"
        class="h-100"
      >
        <b-container class="h-100">
          <b-row
            align-v="center"
            class="h-100"
          >
            <InteractivePlotAoFConf
              ref="interactivePlot"
              :show-legends="showLegengsPlotly"
              @change="updateTable"
            />
          </b-row>
        </b-container>
        <div class="btn-over">
          <b-button
            v-b-hover="handleDeleteHover"
            v-b-tooltip.hover.bottom="'Erase all'"
            size="sm"
            variant="danger"
            @click="eraseAll"
          >
            <b-icon
              v-if="hoverDelete"
              aria-label="Clear all"
              icon="trash"
            />
            <b-icon
              v-else
              aria-label="Clear all"
              icon="trash-fill"
            />
          </b-button>
          <b-button
            v-if="typeof(fileArea)!=='undefined'"
            v-b-tooltip.hover.bottom="'Reset from File'"
            size="sm"
            variant="info"
            @click="reloadFile"
          >
            <b-icon
              aria-label="Reload File"
              icon="box-arrow-in-down-right"
            />
          </b-button>
          <b-button
            v-b-tooltip.hover.bottom="'Export areas'"
            size="sm"
            variant="warning"
            @click="exportCSVAreas"
          >
            <b-icon
              aria-label="Reload File"
              icon="box-arrow-up-right"
            />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-form-checkbox
      v-model="showLegengsPlotly"
      class="show-legends-plotly"
      name="checkbox-show-legend"
      :switch="true"
    >
      Show Legends
    </b-form-checkbox>
  </b-container>
</template>

<script>
// https://github.com/TheoXiong/vue-table-dynamic
import { mapGetters, mapActions } from 'vuex'
import InteractivePlotAoFConf from '@/components/configWindow/elements/InteractivePlotAoFConf'
import {hiddenConfCtrller} from '@/assets/classes/configuration.js'
import VueTableDynamic from 'vue-table-dynamic'
import { TypeAxis } from '@/common/plotDefinitions.js'
import { ExtraConfigKey, ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { DATA_TYPE_AOF } from '@/common/sharedDefinitions/dataExtractors/baseExtractor.js'
import { getReportFiles } from '@/common/commonFunctions.js';

const zoneNotify='AreasOfInteresConfig'

export default {  
  name: 'AreasOfInterest',
  components: {
    InteractivePlotAoFConf,
    VueTableDynamic,
  },
  props:{
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data(){
    return {
      configuration:{},
      paramsTable: {
        data: [['Index','Id','X1','X2']],
        header: 'row',
        border: true,
        stripe: true,
        edit:{column: [1,2,3]},
        showCheck: true
      },
      hoverDelete:false,
      hoverAdd:false,
      fileArea:undefined,
      anySelected:false,
      AreasHiddenCtrller: new hiddenConfCtrller(`${ConfigName.BaseFeatureCheck}.aoiTimes`,[]),
      elementsConfig: [],
      showLegengsPlotly:false
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
    'getAreasAoFConf',
    'getDataAoFConf',
    'getMinValueXAoFConf',
    'getMaxValueXAoFConf'
  ]),
  watch: {
    getAreasAoFConf(newValue){
      this.AreasHiddenCtrller.setValue(newValue)
    },
  },
  created(){
    this.elementsConfig= [
        this.AreasHiddenCtrller,
      ]
  },
  async mounted() {
    await this.initializeComponent()
    this.updateAllContentTable()
  },
  methods: {
    ...mapActions([
      'updateTableAreaAoFConf',
      'resetAreasAoFConf',
      'setAreaAoFConf',
      'deleteAreaAoFConf',
      'addAreaAoFConf',
      'setSelectionFlagAoFConf',
      'updateXAxisAoFConf',
      'removeFromInitReqConfWindow',
      'setReportModifiedReportViewer',
    ]),
    isReady(){
      for(let j=0;j<this.elementsConfig.length;j++){
        if(!this.elementsConfig[j].isReady()){
          return false
        }
      }
      return true
    },
    done(){
      this.setSelectionFlagAoFConf(false)
      this.removeFromInitReqConfWindow({type:'AREA_INTEREST_VALUES', study: this.sectionconfig})
    },
    async initializeComponent(){
      this.configuration=this.getCurrentReportViewer.configuration
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this)) //When the configuration changes, it updates the values with the controllers
      
      //Search a file with areas
      const reportFiles =  await getReportFiles(this.getCurrentReportViewer)
      this.fileArea = reportFiles.find(file=>file.dataType===DATA_TYPE_AOF)

      // Quick validation of the input data
      if(this.getAreasAoFConf.length=== 0 || this.getAreasAoFConf[0].length < 3){
        const infoTitle='Incorrect information'
        const infoText='The stored areas are not valid. Please contact the adminstrator of the system.'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO,infoTitle,infoText,zoneNotify)
        this.setAreaAoFConf([]) // Reset the value
        await this.updatePlotly()
        await this.updateTable()
      }
      this.AreasHiddenCtrller.setValue(this.getAreasAoFConf)
    },
    onCellChange (rowIndex, columnIndex, rawData) {
      this.setReportModifiedReportViewer()
      const data = typeof(rawData) === 'number' ? rawData : String(rawData).replace(/<\/?[^>]+(>|$)/g, '');
      this.updateTableAreaAoFConf({row:rowIndex-1,arrIndex:columnIndex-1,newXVal:data})
      this.updatePlotly()
    },
    onCellSelected(){
      this.anySelected = this.$refs.tableArea.getCheckedRowDatas().length > 0
    },
    async verifyData(){
      const fullXAxis = this.getMaxValueXAoFConf - this.getMinValueXAoFConf
      const areas = this.getAreasAoFConf
      // Auxliar boolans
      let updateAll = false
      let greaterThanMax = false
      let lessThanMin = false
      let equalValues = false
      for(let j=0;j<areas.length;j++){
        if(areas[j][1] > areas[j][2]){ // If one value is greater than the other just change the order
          const auxValue = areas[j][2]
          areas[j][2] = areas[j][1]
          areas[j][1] = auxValue
          this.updateXAxisAoFConf({index:j,newXVal:areas[j]})
        }
        if(areas[j][1] === areas[j][2]){ // Values can't be equal
          equalValues = true
          areas[j][2] += (fullXAxis * 0.05)
        }
        if(areas[j][2] > this.getMaxValueXAoFConf){
          updateAll = true
          greaterThanMax = true
          areas[j][2] = this.getMaxValueXAoFConf
          if(areas[j][1] >= areas[j][2]){ // Means the X1 value was also greater than the maximum
            areas[j][1] = areas[j][2] - (fullXAxis * 0.05)
          }
        }
        if(areas[j][1] < this.getMinValueXAoFConf){
          updateAll = true
          lessThanMin = true
          areas[j][1] = this.getMinValueXAoFConf
          if(areas[j][1] <= areas[j][2]){ // Means the X1 value was also greater than the maximum
            areas[j][1] = areas[j][2] + (fullXAxis * 0.05)
          }
        }
      }
      if(equalValues){
        const errTitle='X1 and X2 equal'
        const errText='The values X1 and X2 can\'t be equal'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
      if(greaterThanMax){
        const errTitle='Value out of range'
        const errText=`All the numbers must be less than or equal to ${this.getMaxValueXAoFConf} (getMaxValueXAoFConf)`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
      if(lessThanMin){
        const errTitle='Value out of range'
        const errText=`All the numbers must be greater than or equal to ${this.getMaxValueXAoFConf} (minimum)`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }
      if(updateAll){
        await this.$nextTick() // Wait to update the table
        this.setAreaAoFConf(areas)
        await this.updatePlotly()
        await this.updateTable()
        return false // Then it does not update again the values
      }
      return true
    },
    async updatePlotly(){
      if(await this.verifyData()){ // Then we avoid unnecessary updates
        this.$refs.interactivePlot.updateAreas()
      }
    },
    async updateTable(){
      if(await this.verifyData()){ // Then we avoid unnecessary updates
        this.updateAllContentTable()
      }
    },
    updateAllContentTable(){
      this.paramsTable.data=[['Index','Id','X1','X2']]
      for(let j=0;j<this.getAreasAoFConf.length;j++){
        this.paramsTable.data.push([j+1].concat(this.getAreasAoFConf[j]))
      }
    },
    handleDeleteHover(hovered) {//Handle the hover on the Add button
      this.hoverDelete = hovered
    },
    handleAddHover(hovered) {//Handle the hover on the Add button
      this.hoverAdd = hovered
    },
    async eraseAll(){
      this.setSelectionFlagAoFConf(false)
      try{
        await this.$confirm(
          'This action will remove all the values. Are you sure?',
          'Delete all',
          'question',
          {
            confirmButtonText: 'Remove All',
          }
        )
        this.resetAreasAoFConf()
        this.$refs.interactivePlot.updateAreas()
      }
      catch{
        return
      }
      this.updatePlotly()
    },
    deleteSelected(){
      const selectedRows=this.$refs.tableArea.getCheckedRowDatas()
      for(let j=0;j<selectedRows.length;j++){
        let relativeRowDel=selectedRows[j][0]-j-1 //It should be modified becuase when you delete one row the others move
        this.deleteAreaAoFConf(relativeRowDel)
      }
      this.updateAllContentTable()
      this.updatePlotly()
    },
    async addValue(){
      this.addAreaAoFConf({
        X1Value: 0, 
        rangeXAxis: this.getMaxValueXAoFConf - this.getMinValueXAoFConf
      })
      this.updateAllContentTable()
      await this.$nextTick() // Wait to update the table
      const divTable = this.$refs.divTable
      divTable.scrollTop = divTable.scrollHeight;
      this.updatePlotly()
    },
    async reloadFile(){
      this.setSelectionFlagAoFConf(false)
      try{
        await this.$confirm(
          'This action will reset the values to your file. Are you sure?',
          'Reset all',
          'question',
          {
            confirmButtonText: 'Reset All',
          }
        )
        const currReportConf = this.getCurrentReportViewer[ExtraConfigKey]
        const newArr= JSON.parse(JSON.stringify(this.fileArea.extractedData))
        //Quick validation of the input data
        if(newArr.length=== 0 || newArr[0].length < 3){
          return
        }
        const timeFactor = TypeAxis.time.getConvertFactor(currReportConf)
        for(let j=0;j<newArr.length;j++){
          newArr[j][1]*=timeFactor
          newArr[j][2]*=timeFactor
        }
        this.setAreaAoFConf(newArr)
        this.$refs.interactivePlot.updateAreas()
      }
      catch{
        return
      }
      this.updatePlotly()
    },
    exportCSVAreas(){
      if(this.getAreasAoFConf.length === 0){
        const infoTitle='No areas'
        const infoText='No areas found in the current report'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO,infoTitle,infoText,zoneNotify)
        return
      }
      // Create the CSV file
      const csvContent = 'data:text/csv;charset=utf-8,' 
        + this.getAreasAoFConf.map(e => e.join('\t')).join('\n');
      const encodedUri = encodeURI(csvContent);

      //Download the file
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = encodedUri;
      a.download = 'AoF_TIMES.aof';
      a.click();
      window.URL.revokeObjectURL(encodedUri);
    },
    
  },
  
}
</script>

<style lang="scss" scoped>
::v-deep .label-input-text{
  font-weight: bold;
  font-size: 0.88rem;
}
.btn-over{
  position:absolute;
  top:0;
  left: 0;
}
.table-div{
  overflow-y: auto;
  height: calc(100% - 3.5rem);
  height: -o-calc(100% - 3.5rem); /* opera */
  height: -webkit-calc(100% - 3.5rem); /* google, safari */
  height: -moz-calc(100% - 3.5rem); /* firefox */
  scroll-behavior: smooth;
}
.table-column{
  box-shadow: 0 4px 8px 0 #ccc;
  border-radius: 10px;
}
::v-deep .v-table-row{
  background-color: #e2ffe0 !important;
}
::v-deep .v-table-row.is-striped{
  background-color: #b1daae !important;
}
.show-legends-plotly{
  padding-top: 0.5rem;
}
</style>